import { createAction, createReducer } from "@reduxjs/toolkit";

const initialState = {
  lessons: [],
  loading: false,
};

const lessonsRequest = createAction("lessonsRequest");
const lessonsSuccess = createAction("lessonsSuccess");
const lessonsFailure = createAction("lessonsFailure");

export const lessonsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(lessonsRequest, (state, action) => {
      state.loading = true;
    })
    .addCase(lessonsSuccess, (state, action) => {
      state.loading = false;
      state.lessons = action.payload.courseLessons;
    })
    .addCase(lessonsFailure, (state, action) => {
      state.loading = false;
    });
});
